import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ScrollToTop from "./components/ScrollToTop";
import AnimatedRoutes from "./components/AnimatedRoutes";
import CookieBanner from "./components/CookieBanner";
import ShopFloatingCart from "./components/shop/ShopFloatingCart";
import { useOnlinePresence } from "@/hooks/useOnlinePresence";
import { CampaignProgressProvider } from "@/contexts/CampaignProgressContext";
import CampaignProgressToast from "./components/organizer/communication/CampaignProgressToast";


const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 120_000,
      gcTime: 10 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function PresenceTracker() {
  // Hook is a no-op for anonymous visitors and only opens a Realtime channel
  // for authenticated users (cost-control: avoid presence WS for guests).
  useOnlinePresence();
  return null;
}

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <CampaignProgressProvider>
          <BrowserRouter>
            <ScrollToTop />
            <PresenceTracker />
            <AnimatedRoutes />
            <CookieBanner />
            <ShopFloatingCart />
            <CampaignProgressToast />
          </BrowserRouter>
        </CampaignProgressProvider>

      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
